import { Canvas } from "@react-three/fiber";
import { useGLTF, useAnimations, OrbitControls } from "@react-three/drei";
import { useEffect } from "react";
import GradientBackground from "./GradientBackground";
import LeaveBackground from "./home/LeaveBackground";

function Model() {
  // 加载模型和动画
  const { scene, animations } = useGLTF("/WEB7.glb");
  const { actions } = useAnimations(animations, scene);

  useEffect(() => {
    // 保持模型原有材质
    scene.traverse((child: any) => {
      if (child.isMesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });

    // 播放动画
    const actionKeys = Object.keys(actions);
    if (actionKeys.length > 0 && actions[actionKeys[0]]) {
      actions[actionKeys[0]]?.play();
    }
  }, [actions, scene]);

  return <primitive object={scene} scale={2} />;
}

export default function Test() {
  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <LeaveBackground></LeaveBackground>
      <Canvas
        shadows
        style={{
          background: "transparent",
          position: "absolute",
          top: 0,
          left: "25%",
          width: "50%",
          height: "100%",
          zIndex: 1000,
        }}
      >
        <OrbitControls
          enableZoom={true}
          enablePan={true}
          enableRotate={true}
          minDistance={2}
          maxDistance={10}
        />

        <ambientLight intensity={1.2} color="#fff" />

        {/* 左前方辅助光源 */}
        <directionalLight
          position={[-5, 5, 5]}
          intensity={0.8}
          color="white"
          castShadow
          shadow-mapSize-width={1024}
          shadow-mapSize-height={1024}
        />

        {/* 右前方主光源 */}
        <directionalLight
          position={[5, 5, 5]}
          intensity={1.5}
          color="white"
          castShadow
          shadow-mapSize-width={1024}
          shadow-mapSize-height={1024}
        />

        <Model />
      </Canvas>
    </div>
  );
}
